export default {
	isEnabled: true,
	PWA_ROUTES: [],
	// Primarily used for SFCC routes
	EXTERNAL_ROUTES: [
		'/on/demandware.store/'
	]
};